import { IDs } from '../../helpers/IDs';
import { getStaticOption } from '../../core/forms/helpers/getStaticOption';

export function getCO2Aequivalent(data: any, jahr: number, key: string, klimagas: boolean) {
    jahr = +jahr;
    /*if (jahr < 2010) {
        console.trace('JAHR???' + jahr);
        alert('Check');
    }*/
    const key_orig = key; // TODO Refactoring
    if (key === 'ladestrom') {
        key = 'strom';
    }
    if (key === 'strom_waerme') {
        key = 'strom';
    }
    if (key === 'fernwaerme') {
        key = 'FW';
    }
    if (key === 'fernkaelte') {
        key = 'FK';
    }
    const rows = klimagas ? data[IDs.ENT_CO2_FAKTOREN_KLIMAGASE] : data[IDs.ENT_CO2_FAKTOREN_INTERN];
    let found: any = null;
    let found_jahr: number = null;
    (rows || []).forEach((item: any) => {
        if (item.info === key) {
            if (found === null) {
                found = item;
                found_jahr = item.jahr;
                /*if (key === 'strom') {
                    console.log('init: ', jahr, found_jahr, item.jahr, key);
                }*/

            } else {
                if (found_jahr === jahr) {
                    return; // Wenn das korrekte Jahr bereits gefunden wurde raus
                }
                if (found_jahr < jahr && item.jahr < found_jahr) {
                    return; // Wir sind unter dem gesuchten Jahr, aber weiter weg vom gefundenen --> raus
                }
                if (found_jahr < jahr && item.jahr > jahr) {
                    return; // Es wurde ein kleineres Jahr als das gesuchte gefunden, damit sind alle anderen obsolete
                }
                if (found_jahr > jahr && item.jahr > found_jahr) {
                    return; // Es wurde ein größeres Jahr gefunden, wir sind aber noch größer --> raus
                }
                // wir sind entweder
                // .. genau das Jahr
                // .. kleiner und näher am gesuchten Jahr
                // .. größer, wenn noch kein kleineres Jahr gefunden wurde und dafür näher dran
                found = item;
                found_jahr = item.jahr;
                /*if (key === 'strom') {
                    console.log('set : ', jahr, found_jahr, item.jahr, key);
                }*/
            }
        }
    });
    /*if (key === 'strom') {
        console.log('done: ', jahr, found_jahr, key);
    }*/
    // console.log('CO2 Key: ', key, key_orig);
    if (key_orig === 'ladestrom') {
        found = { ...found };
        found.name = 'Ladestrom';
    }
    if (key_orig === 'strom_waerme') {
        found = { ...found };
        found.name = 'Heizstrom';
    }
    // console.log('Faktor Check: ', found);
    // console.trace('Unbekannter Faktor', key);
    return found || { name: 'Unbekannt [1]: ' + key, wert: 0 };
}
export function getCO2AequivalentGasKeys(data: any) {
    return (data[IDs.ENT_KLIMAGASE_ART] || []).map((k: any) => k.info).sort();
}
export function getCO2AequivalentSubscopes(entity: string, data: any, jahr: number, id: any, att: string, einheit?: string, srcEntity?: string, srcName?: string, dataRows?: Array<any>) {
    const rows = dataRows || data[entity] || [];
    const result = getCO2AequivalentSubscopesRows(rows, jahr, id, att, einheit);
    if (!result.name && srcName) {
        result.name = getStaticOption(srcEntity, srcName, id);
    }
    if (result.invalid) {
        if (!data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN]) {
            data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN] = {};
        }
        const faktorKey = `${entity}_${jahr}_${id}`;
        if (!data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN][faktorKey]) {
            data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN][faktorKey] = entity;
            console.error('Ungültiger Faktor!', entity, jahr, id);
        }
    }
    return result;
}

export function getCO2AequivalentSubscopesRows(rows: Array<any>, jahr: number, id: any, att: string, einheit?: string) {
    jahr = +jahr;
    let found: any = null;
    let found_jahr: number = null;
    rows.forEach((item: any) => {
        if (item[att] === id) {
            // Einheit prüfen
            if (einheit && (!item.einheit || item.einheit !== einheit)) {
                // Nur wenn eine spezifische einheit erwartet wird, und diese nicht gefunden wird ...
                return;
            }
            if (found === null) {
                found = item;
                found_jahr = item.jahr;
            } else {
                if (found_jahr === jahr) {
                    return; // Wenn das korrekte Jahr bereits gefunden wurde raus
                }
                if (found_jahr < jahr && item.jahr < found_jahr) {
                    return; // Wir sind unter dem gesuchten Jahr, aber weiter weg vom gefundenen --> raus
                }
                if (found_jahr < jahr && item.jahr > jahr) {
                    return; // Es wurde ein kleineres Jahr als das gesuchte gefunden, damit sind alle anderen obsolete
                }
                if (found_jahr > jahr && item.jahr > found_jahr) {
                    return; // Es wurde ein größeres Jahr gefunden, wir sind aber noch größer --> raus
                }
                // wir sind entweder
                // .. genau das Jahr
                // .. kleiner und näher am gesuchten Jahr
                // .. größer, wenn noch kein kleineres Jahr gefunden wurde und dafür näher dran
                found = item;
                found_jahr = item.jahr;
            }
        }
    });
    // console.log(found, id);
    return found || { name: 'Unbekannt [2]: ' + id, wert: 0, invalid: true };
}

export function getCO2AequivalentSubscope1(data: any, jahr: number, name: string, einheit?: string) {
    // console.log('getCO2AequivalentSubscope1', jahr, einheit, name);
    return getCO2AequivalentSubscopes(IDs.ENT_CO2_SCOPE3_FAKTOREN_MATERIAL, data, jahr, name, 'name', einheit);
}
export function getCO2AequivalentSubscope2(data: any, jahr: number, name: string, einheit?: string) {
    return getCO2AequivalentSubscopes(IDs.ENT_CO2_SCOPE3_FAKTOREN_GUETER, data, jahr, name, 'name', einheit);
}
export function getCO2AequivalentSubscope49(data: any, jahr: number, id: number, srcEntity: string, srcName: string) {
    return getCO2AequivalentSubscopes(IDs.ENT_CO2_SCOPE3_FAKTOREN_TRANSPORT, data, jahr, id, 'info', null, srcEntity, srcName);
}
export function getCO2AequivalentSubscope5(data: any, jahr: number, values: any) {
    const dataRows = (data[IDs.ENT_CO2_SCOPE3_FAKTOREN_ABFAELLE] || []).filter((r: any) => r.kategorie === values.kategorie
        && (!values.unterkategorie || r.unterkategorie === values.unterkategorie));
    let faktor = getCO2AequivalentSubscopes(IDs.ENT_CO2_SCOPE3_FAKTOREN_ABFAELLE, data, jahr, values.kategorie, 'kategorie', null, null, null, dataRows);
    faktor = { ...faktor };
    // console.log('getCO2AequivalentSubscope5', faktor, values);
    if (faktor && values.verfahren) {
        if (faktor[`wert_${values.verfahren}`]) {
            faktor.wert = faktor[`wert_${values.verfahren}`];
        }
        if (faktor[`quelle_${values.verfahren}`]) {
            faktor.quelle = faktor[`quelle_${values.verfahren}`];
        }
        if (faktor[`datenqualitaet_${values.verfahren}`]) {
            faktor.datenqualitaet = faktor[`datenqualitaet_${values.verfahren}`];
        }
    }
    return faktor;
}
export function getCO2AequivalentSubscope6_Uebernachtung(data: any, jahr: number, id: number) {
    return getCO2AequivalentSubscopes(IDs.ENT_CO2_SCOPE3_FAKTOREN_REISEN_UEBERNACHTUNG, data, jahr, id, 'info');
}
export function getCO2AequivalentSubscope69_Unterkunft(data: any, jahr: number, id: number) {
    return getCO2AequivalentSubscopes(IDs.ENT_CO2_SCOPE3_FAKTOREN_TRANSPORT_UNTERKUNFT, data, jahr, id, 'unterkunft');
}
export function getCO2AequivalentSubscope24_Raeume(data: any, jahr: number, id: string) {
    return getCO2AequivalentSubscopes(IDs.ENT_CO2_SCOPE3_FAKTOREN_ANGEMIETETE_RAEUMLICHKEITEN, data, jahr, id, 'nutzungsart');
}
export function getCO2AequivalentSubscope24_Fahrzeuge(data: any, jahr: number, row: any) {
    const rows = data[IDs.ENT_CO2_SCOPE3_FAKTOREN_ANGEMIETETE_FAHRZEUGE];
    const transportmittel = row.transportmittel;
    const kraftstoff = row.kraftstoff;
    const found_rows = rows.filter((item: any) => {
        if (transportmittel === 'pkw_klein' || transportmittel === 'pkw_mittel' || transportmittel === 'pkw_gross') {
            return kraftstoff === item.kraftstoff && row.transportmittel === item.info;
        } else {
            return row.transportmittel === item.info;
        }
    });
    let found: any = null;
    let found_jahr: number = null;
    // console.log('SS6 Faktor', found_rows, transportmittel, rows);
    found_rows.forEach((item: any) => {
        if (found === null) {
            found = item;
            found_jahr = item.jahr;
        } else {
            if (found_jahr === jahr) {
                return; // Wenn das korrekte Jahr bereits gefunden wurde raus
            }
            if (found_jahr < jahr && item.jahr < found_jahr) {
                return; // Wir sind unter dem gesuchten Jahr, aber weiter weg vom gefundenen --> raus
            }
            if (found_jahr < jahr && item.jahr > jahr) {
                return; // Es wurde ein kleineres Jahr als das gesuchte gefunden, damit sind alle anderen obsolete
            }
            if (found_jahr > jahr && item.jahr > found_jahr) {
                return; // Es wurde ein größeres Jahr gefunden, wir sind aber noch größer --> raus
            }
            // wir sind entweder
            // .. genau das Jahr
            // .. kleiner und näher am gesuchten Jahr
            // .. größer, wenn noch kein kleineres Jahr gefunden wurde und dafür näher dran
            found = item;
            found_jahr = item.jahr;
        }
    });
    const transpName = getStaticOption(IDs.ENT_ANGEMIETETE_FAHRZEUGE, 'transportmittel', transportmittel, null, true);
    return found || { name: transpName || `Unbekanntes Transportmittel (${transportmittel})`, wert: 0 };
}

export function getCO2AequivalentSubscope6_Entfernung(data: any, jahr: number, row: any, tp_key?: string) {
    const rows = data[IDs.ENT_CO2_SCOPE3_FAKTOREN_REISEN_ENTFERNUNG];
    const transportmittel = tp_key ? row[tp_key] : row.transportmittel;
    const kraftstoff = tp_key ? row.kraftstoff_distance : row.kraftstoff;
    // console.log('Faktor 6: ', tp_key, transportmittel, row);
    const found_rows = rows.filter((item: any) => {
        // console.log('S7 - Item', transportmittel, item);
        let isStrom = false;
        if (transportmittel === 'bahn' || transportmittel === 'bahn_fern' ||
            transportmittel === 'bus' || transportmittel === 'reisebus' || transportmittel === 'tram' ||
            transportmittel === 'flugzeug_national' || transportmittel === 'flugzeug_international' || transportmittel === 'krad' ||
            transportmittel === 'personen_boden' || transportmittel === 'flugzeug_spend_based') {
            return transportmittel === item.info;
        } else if (transportmittel === 'pkw_hybrid' || transportmittel === 'pkw_klein' || transportmittel === 'pkw_mittel' || transportmittel === 'pkw_gross') {
            if (row.kraftstoff === 'strom') {
                isStrom = true;
            } else {
                // Bei "echten" Kraftstoffen nur Kraftstoff und Größe
                return kraftstoff === item.kraftstoff && transportmittel === item.info;
            }
        } else if (transportmittel === 'e_bike') {
            isStrom = true;
        }
        if (isStrom) {
            // WICHTIG: Lieferantenstrom wird schon vorher abgefangen, also kommt hier nicht mehr rein
            // Entweder mix, oder Regenerativ + entsprechende Art des reg. Stroms
            return transportmittel === item.info && ((row.strom === 'mix' && item.strom === 'mix') ||
                (row.strom === 'regenerativ' && item.strom === 'regenerativ' && row.strom_regenerativ === item.strom_regenerativ));
        }

    });
    let found: any = null;
    let found_jahr: number = null;
    // console.log('SS6 Faktor', found_rows, transportmittel, rows);
    found_rows.forEach((item: any) => {

        if (found === null) {
            found = item;
            found_jahr = item.jahr;
        } else {
            if (found_jahr === jahr) {
                return; // Wenn das korrekte Jahr bereits gefunden wurde raus
            }
            if (found_jahr < jahr && item.jahr < found_jahr) {
                return; // Wir sind unter dem gesuchten Jahr, aber weiter weg vom gefundenen --> raus
            }
            if (found_jahr < jahr && item.jahr > jahr) {
                return; // Es wurde ein kleineres Jahr als das gesuchte gefunden, damit sind alle anderen obsolete
            }
            if (found_jahr > jahr && item.jahr > found_jahr) {
                return; // Es wurde ein größeres Jahr gefunden, wir sind aber noch größer --> raus
            }
            // wir sind entweder
            // .. genau das Jahr
            // .. kleiner und näher am gesuchten Jahr
            // .. größer, wenn noch kein kleineres Jahr gefunden wurde und dafür näher dran
            found = item;
            found_jahr = item.jahr;
        }
    });
    if (!found) {
        if (!data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN]) {
            data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN] = {};
        }
        const faktorKey = `${IDs.ENT_CO2_SCOPE3_FAKTOREN_REISEN_ENTFERNUNG}_${jahr}_${transportmittel}`;
        if (!data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN][faktorKey]) {
            data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN][faktorKey] = row;
            console.error('Ungültiger Faktor!', IDs.ENT_CO2_SCOPE3_FAKTOREN_REISEN_ENTFERNUNG, jahr, transportmittel, row);
        }
    }
    const transpName = getStaticOption(IDs.ENT_CO2_SCOPE3_REISEN, 'transportmittel', transportmittel, null, true);
    return found || { name: transpName || `Unbekanntes Transportmittel (${transportmittel})`, wert: 0 };
}
export function getCO2AequivalentSubscope7(data: any, jahr: number, row: any) {
    const rows = data[IDs.ENT_CO2_SCOPE3_FAKTOREN_PENDELN];
    const transportmittel = row.transportmittel;
    const kraftstoff = row.kraftstoff;
    const found_rows = rows.filter((item: any) => {
        if (transportmittel === 'bahn' || transportmittel === 'bahn_fern' ||
            transportmittel === 'bus' || transportmittel === 'reisebus' || transportmittel === 'tram' ||
            transportmittel === 'e_bike' || transportmittel === 'krad' ||
            transportmittel === 'flugzeug_national' || transportmittel === 'flugzeug_international' ||
            transportmittel === 'personen_boden' || transportmittel === 'flugzeug_spend_based') {
            return item.transportmittel === transportmittel;
        } else if (transportmittel === 'pkw_hybrid' || transportmittel === 'pkw_klein' || transportmittel === 'pkw_mittel' || transportmittel === 'pkw_gross') {
            if (!kraftstoff) {
                return !item.kraftstoff && item.transportmittel === transportmittel;
            } else {
                return item.kraftstoff === kraftstoff && item.transportmittel === transportmittel;
            }
        }
        return false;
    });
    // console.log('S7 FAKT', transportmittel, kraftstoff, jahr, found_rows, row, rows);
    let found: any = null;
    let found_jahr: number = null;
    found_rows.forEach((item: any) => {
        if (found === null) {
            found = item;
            found_jahr = item.jahr;
        } else {
            if (found_jahr === jahr) {
                return; // Wenn das korrekte Jahr bereits gefunden wurde raus
            }
            if (found_jahr < jahr && item.jahr < found_jahr) {
                return; // Wir sind unter dem gesuchten Jahr, aber weiter weg vom gefundenen --> raus
            }
            if (found_jahr < jahr && item.jahr > jahr) {
                return; // Es wurde ein kleineres Jahr als das gesuchte gefunden, damit sind alle anderen obsolete
            }
            if (found_jahr > jahr && item.jahr > found_jahr) {
                return; // Es wurde ein größeres Jahr gefunden, wir sind aber noch größer --> raus
            }
            // wir sind entweder
            // .. genau das Jahr
            // .. kleiner und näher am gesuchten Jahr
            // .. größer, wenn noch kein kleineres Jahr gefunden wurde und dafür näher dran
            found = item;
            found_jahr = item.jahr;
        }
    });
    if (!found) {
        if (!data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN]) {
            data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN] = {};
        }
        const faktorKey = `${IDs.ENT_CO2_SCOPE3_FAKTOREN_PENDELN}_${jahr}_${transportmittel}_${kraftstoff}`;
        if (!data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN][faktorKey]) {
            data[IDs.SYSINFO_UNGUELTIGE_FAKTOREN][faktorKey] = row;
            console.error('Ungültiger Faktor!', IDs.ENT_CO2_SCOPE3_FAKTOREN_PENDELN, jahr, transportmittel, kraftstoff, row);
        }
    }
    const transpName = getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'transportmittel', transportmittel, null, true);
    const kraftName = getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'kraftstoff', kraftstoff, null, true);
    return found || { name: transpName || kraftName || `Unbekanntes Transportmittel (${transportmittel} / ${kraftName})`, wert: 0 };
}


